import { BaseAPI } from '../../BaseApi';
import { ICommentResponse } from '../../../types/order/comment/IComment';
import { UUID } from '../../../types/shared/UUID';
import { eAPITags } from '../../eAPITags';
import { ICommentTableEntry } from '../../../components/order/comments/CommentsTable';
import { convertICommentResponseToICommentTableEntry } from '../../../components/order/comments/utilities/convertICommentResponseToICommentTableEntry';
import { ICommentCreateRequest, ICommentEditRequest } from './Comments';
import { eCommentScope } from '../../../types/order/comment/eCommentScope';
import { convertIVendorCommentResponseToICommentTableEntry } from '../../../components/order/comments/utilities/convertIVendorCommentResponseToICommentTableEntry';
import { eAuthorType } from '../../../types/order/comment/eAuthorTypes';

export const CommentsApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listComments: build.query<ICommentTableEntry[], { orderId: UUID; scope: eCommentScope }>({
      query: ({ orderId, scope }) => `/timber/api/internal/orders/${orderId}/comments?scope=${scope}`,
      providesTags: (response, error, { orderId, scope }) => [
        { type: eAPITags.OrderComments, id: orderId, scope: scope },
      ],
      transformResponse: (baseReturnValue: ICommentResponse[]) =>
        baseReturnValue.map((it) => {
          if (it.relevantParty === eAuthorType.Vendor || it.relevantParty === eAuthorType.VendorUser) {
            return convertIVendorCommentResponseToICommentTableEntry(it);
          } else {
            return convertICommentResponseToICommentTableEntry(it);
          }
        }),
    }),
    createComment: build.mutation<ICommentResponse, ICommentCreateRequest>({
      query: ({ orderId, content, type, scope }) => ({
        url: `/timber/api/internal/orders/${orderId}/comments`,
        method: 'POST',
        body: { content, type, scope },
      }),
      invalidatesTags: (response, error, { orderId, scope }) => [
        { type: eAPITags.OrderComments, id: orderId, scope: scope },
      ],
    }),
    editComment: build.mutation<ICommentResponse, ICommentEditRequest>({
      query: ({ orderId, commentId, type, scope }) => ({
        url: `/timber/api/internal/orders/${orderId}/comments/${commentId}`,
        method: 'PATCH',
        body: { type },
      }),
      invalidatesTags: (response, error, { orderId, scope }) => [
        { type: eAPITags.OrderComments, id: orderId, scope: scope },
      ],
    }),
  }),
});

export const { useListCommentsQuery, useCreateCommentMutation, useEditCommentMutation } = CommentsApi;
